import { render, staticRenderFns } from "./unpacked.vue?vue&type=template&id=36e4711b&scoped=true"
import script from "./unpacked.vue?vue&type=script&lang=js"
export * from "./unpacked.vue?vue&type=script&lang=js"
import style0 from "./unpacked.vue?vue&type=style&index=0&id=36e4711b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4711b",
  null
  
)

export default component.exports